import React from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { isArray } from 'util'
import { formatTime } from '@/utils'
import { $post } from '@/api'
import { useRequest } from 'ahooks'
import { IPagination } from '@/model/types/common'
import { isNoMore, WithScrollLoad } from '@/utils/utils-widget'

interface IProps {
    goodsId: number
}

interface ISellRecord {
    amount: number
    order_no: string
    price: number
    sales_time: string
    subtotal: number
}

export const SellRecord: React.FC<IProps> = props => {
    const cloumns: ColumnsType<ISellRecord> = [
        {
            title: '#',
            key: '#',
            align: 'center',
            width: '40px',
            render: (text, record, index) => <div>{index + 1}</div>,
        },
        {
            title: '时间',
            render: (text, record) => (
                <div data-column>
                    {!isArray(formatTime(record.sales_time)) ? (
                        // 需要根据实际数据处理
                        <span>{formatTime(record.sales_time)}</span>
                    ) : (
                        <React.Fragment>
                            <span>{formatTime(record.sales_time)[0]}</span>
                            <span>{formatTime(record.sales_time)[1]}</span>
                        </React.Fragment>
                    )}
                </div>
            ),
        },
        {
            title: '实售单价',
            align: 'right',
            key: 'price',
            dataIndex: 'price',
            render: text => <div>¥{text}</div>,
        },
        {
            title: '销售量',
            align: 'right',
            key: 'amount',
            dataIndex: 'amount',
        },
        {
            title: '销售额',
            align: 'right',
            key: 'subtotal',
            dataIndex: 'subtotal',
            render: text => <div>¥{text}</div>,
        },
    ]

    const requestHandle = useRequest<
        {
            list: ISellRecord[]
            pagination: IPagination
        },
        {
            records: ISellRecord[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/goods/getgoodssalesrecords',
                params: {
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    limit: 20,
                    goods_id: props.goodsId,
                },
            })
        },
        {
            isNoMore: isNoMore,
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.records,
                    pagination: data.pagination,
                }
            },
        },
    )

    return (
        <div data-margin-top-10>
            <WithScrollLoad scrollloadhandle={requestHandle}>
                <Table
                    rowKey={r => r.order_no}
                    columns={cloumns}
                    dataSource={requestHandle.data?.list}
                    bordered
                    loading={requestHandle.loadingMore || requestHandle.loading || void 0}
                    pagination={false}
                    scroll={{ y: '400px' }}
                ></Table>
            </WithScrollLoad>
        </div>
    )
}
